module.exports = __webpack_public_path__ + "static/media/tip3.f6857cdb.svg";